import { useEffect } from 'react';
import { AuthProvider } from '@/contexts/AuthContext';
import { RealtimeBridge } from '@/realtime/RealtimeBridge';
import { bootstrapStores } from '@/stores/bootstrap';
import { registerDefaultCommands } from '@/features/keyboard-shortcuts/keyboardRegistry';
import { useGlobalKeyboard } from '@/features/keyboard-shortcuts/hooks/useGlobalKeyboard';
import { initIOSPwaNavigation } from '@/lib/iosPwaNavigation';
import { initPwaUpdates } from '@/lib/pwaUpdate';
import { useIsMobile } from '@/hooks/useIsMobile';
import { AppShell } from './AppShell';
import { Toaster } from '@/components/ui/sonner';

// Register keyboard commands at module load time so they're available before any component renders
registerDefaultCommands();

export default function App() {
  useEffect(() => {
    const cleanupBootstrap = bootstrapStores();
    const cleanupIOSPwa = initIOSPwaNavigation();
    initPwaUpdates();

    return () => {
      cleanupBootstrap();
      cleanupIOSPwa();
    };
  }, []);

  // Enable global keyboard shortcuts
  useGlobalKeyboard();

  // Bottom edge on mobile belongs to the nav / action bars — toasts go top-center
  // there so undo stays visible and tappable.
  const isMobile = useIsMobile();

  return (
    <AuthProvider>
      <RealtimeBridge />
      <AppShell />
      <Toaster
        position={isMobile ? 'top-center' : 'bottom-right'}
        offset={isMobile ? { top: 'calc(env(safe-area-inset-top, 0px) + 12px)' } : undefined}
        mobileOffset={isMobile ? { top: 'calc(env(safe-area-inset-top, 0px) + 12px)' } : undefined}
      />
    </AuthProvider>
  );
}
